export const MIND = 'MIND';
export const KNOWLEDGE = 'KNOWLEDGE';
